export enum AdvanceDirectiveTypeEnum {
  LivingWill = 1,
  DNR = 2,
  DNI = 3,
  POLST = 4,
  MOLST = 5,
  PowerOfAttorney = 6,
  HealthcareSurrogate = 7,
  FullCode = 8,
  Other = 99
}

export const AdvanceDirectiveTypeOptions = [
{ id: 1, label: 'Living Will', requiresDocumentation: true, requiresContact: false, storedDocumentTypeId: 1, displayForQuickAccess: false, abbreviation: 'Living Will' },
{ id: 2, label: 'DNR (Do Not Resuscitate)', requiresDocumentation: true, requiresContact: false, storedDocumentTypeId: 2, displayForQuickAccess: true, abbreviation: 'DNR' },
{ id: 3, label: 'DNI (Do Not Incubate)', requiresDocumentation: true, requiresContact: false, storedDocumentTypeId: 3, displayForQuickAccess: false, abbreviation: 'DNI' },
{ id: 4, label: 'POLST (Physician Orders for List-Sustaining Treatment)', requiresDocumentation: true, requiresContact: false, storedDocumentTypeId: 4, displayForQuickAccess: true, abbreviation: 'POLST' },
{ id: 5, label: 'MOLST (Medical Orders for List-Sustaining Treatment)', requiresDocumentation: true, requiresContact: false, storedDocumentTypeId: 5, displayForQuickAccess: true, abbreviation: 'MOLST' },
{ id: 6, label: 'Medical Power Of Attorney', requiresDocumentation: true, requiresContact: true, storedDocumentTypeId: 6, displayForQuickAccess: true, abbreviation: 'Medical POA' },
{ id: 7, label: 'Healthcare Surrogate/Decision Maker', requiresDocumentation: true, requiresContact: true, storedDocumentTypeId: 15, displayForQuickAccess: false, abbreviation: 'Healthcare Surrogate' },
{ id: 8, label: 'Full Code', requiresDocumentation: false, requiresContact: false, displayForQuickAccess: false, abbreviation: 'Full Code' },
{ id: 99, label: 'Other/Additional Directives', requiresDocumentation: false, requiresContact: false, displayForQuickAccess: false, abbreviation: 'Other' }
];
